export default __webpack_public_path__ + "static/media/controlledAccess.1aa9756e.png";